import {createSlice, isAnyOf} from "@reduxjs/toolkit";

import {
  addDisapprovementReason,
  addProform,
  addProformApproval,
  approveProform,
  declineProform,
  declineProformApproval,
  deleteDisapprovementReasons,
  fetchAllRejectedProforms,
  fetchForCurrentApproval,
  fetchForRequestById,
  fetchForUserApprovals,
  fetchProformById,
  fetchProforms,
  fetchRejectedProform,
  fetchRejectedProformsFilters,
  sendProformForControl,
  sendProformToFactory,
  unblockProform,
} from "../operations/ProformOperations";

//extraactions from operations
const extraActions = [
  fetchProformById,
  fetchForRequestById,
  fetchProforms,
  addProform,
  sendProformForControl,
  approveProform,
  declineProform,
  sendProformToFactory,
  fetchForCurrentApproval,
  fetchForUserApprovals,
  addDisapprovementReason,
  addProformApproval,
  declineProformApproval,
  fetchAllRejectedProforms,
  fetchRejectedProformsFilters,
  fetchRejectedProform,
  unblockProform,
];
const getItems = type => extraActions.map(action => action[type]);

const initialState = {
  proforms: null,
  currentProform: null,
  currentForRequest: null,

  currentApproval: null,
  approvals: null,
  proformsLoading: false,
  userApprovals: null,

  rejectedProforms: [],
  rejectedProform: null,
  rejectedProformsFilters: [],

  error: [],
};

const ProformSlice = createSlice({
  name: "proforms",
  initialState,
  reducers: {
    setCurrentApproval: (state, {payload}) => {
      state.currentApproval = payload;
      state.approvals = (state.approvals || []).map(approval => {
        if (approval?.approvalId === payload?.approvalId) {
          return {...approval, ...payload};
        }
        return approval;
      });
    },
    setCurrentPf: (state, {payload}) => {
      state.currentProform = payload;
    },
    deselectCurrentPf: (state, {payload}) => {
      state.currentProform = null;
    },
  },
  extraReducers: builder => {
    builder
      //for get requests
      .addCase(fetchProformById.fulfilled, (state, {payload}) => {
        state.currentProform = payload;
      })
      .addCase(fetchForRequestById.fulfilled, (state, {payload}) => {
        state.currentForRequest = payload;
      })
      .addCase(fetchProforms.fulfilled, (state, {payload}) => {
        state.proforms = payload;
      })
      //get requests from proform approvals
      .addCase(fetchForCurrentApproval.fulfilled, (state, {payload}) => {
        state.approvals = payload;
      })
      .addCase(fetchForUserApprovals.fulfilled, (state, {payload}) => {
        state.userApprovals = payload;
      })

      //for post, put, patch requests
      // Закоментовано, тому що стейт оновлюється викликом dispatch(fetchForRequestById)
      // .addCase(addProform.fulfilled, (state, {payload}) => {
      //   state.currentForRequest.request.proforms.unshift(payload);
      // })
      .addCase(addDisapprovementReason.fulfilled, (state, {payload}) => {
        state.currentApproval.disapprovalReasons = [
          ...state.currentApproval.disapprovalReasons,
          ...(payload?.data ?? []),
        ];
      })
      .addCase(deleteDisapprovementReasons.fulfilled, (state, {meta}) => {
        const newDisapprovalReasons = state.currentApproval.disapprovalReasons.filter(
          ({reasonId}) => !meta.arg.reasonIds?.includes(reasonId),
        );

        state.currentApproval.disapprovalReasons = newDisapprovalReasons;
        state.approvals = state.approvals.map(approval => {
          if (approval.approvalId === meta.arg.approvalId) {
            approval.disapprovalReasons = newDisapprovalReasons;
          }
          return approval;
        });
      })
      .addCase(declineProformApproval.fulfilled, (state, {payload}) => {
        state.approvals = state.approvals.map(approval => {
          if (approval.approvalId === payload.approvalId) return {...approval, isDeclined: true};
          return approval;
        });
      })
      .addCase(sendProformForControl.fulfilled, (state, {payload}) => {
        // state.currentForRequest.request.proforms.unshift(payload);
      })
      .addCase(fetchAllRejectedProforms.fulfilled, (state, {payload}) => {
        state.rejectedProforms = payload?.data;
      })
      .addCase(fetchRejectedProform.fulfilled, (state, {payload}) => {
        state.rejectedProform = payload;
      })
      .addCase(fetchRejectedProformsFilters.fulfilled, (state, {payload}) => {
        state.rejectedProformsFilters = payload?.data;
      })

      //matchers
      .addMatcher(isAnyOf(...getItems("fulfilled")), state => handleFulfilled(state))
      .addMatcher(isAnyOf(...getItems("pending")), state => handlePending(state))
      .addMatcher(isAnyOf(...getItems("rejected")), (state, {error}) => handleRejected(state, error));
  },
});

//matcher functions
function handleFulfilled(state) {
  state.proformsLoading = false;
  state.error = [];
}

function handlePending(state) {
  state.proformsLoading = true;
  state.error = [];
}

function handleRejected(state, error) {
  state.proformsLoading = false;
  state.error = error;
}

//actions, reducer
const {actions, reducer} = ProformSlice;

export const {setCurrentApproval, setCurrentPf, deselectCurrentPf} = actions;

export default reducer;
